import { createFileRoute } from "@tanstack/react-router";

import { BoardsPage } from "~/pages/boards.page";

export const Route = createFileRoute("/_app/boards/")({
  component: BoardsPage,
});
